<template>
  <div :class="['pagination-container', { 'hidden': hidden }]">
    <el-pagination
        background
        :layout="layout"
        :page-sizes="pageSizes"
        :page-size.sync="pageSize"
        :current-page.sync="currentPage"
        :total="total"
        v-bind="$attrs"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    // ⭐ 总条数
    total: {
      type: Number,
      required: true
    },
    // ⭐ 当前页码 (支持 .sync)
    page: {
      type: Number,
      default: 1
    },
    // ⭐ 每页条数 (支持 .sync)
    limit: {
      type: Number,
      default: 10
    },
    // 每页条数选项
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    },
    // 布局
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    // 是否隐藏（数据为空时自动隐藏）
    autoHidden: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentPage: {
      get() { return this.page },
      set(val) { this.$emit('update:page', val) }
    },
    pageSize: {
      get() { return this.limit },
      set(val) { this.$emit('update:limit', val) }
    },
    hidden() {
      return this.autoHidden && this.total === 0
    }
  },
  methods: {
    handleSizeChange(val) {
      // 切换每页条数 → 重置到第一页
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        // 如果已经在第一页，手动触发请求
        this.$emit('pagination', { page: 1, limit: val })
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  },
  watch: {
    // 当 currentPage 被重置为1时（如搜索/切换pageSize），也需要触发请求
    currentPage(val) {
      if (val === 1) {
        this.$nextTick(() => {
          this.$emit('pagination', { page: 1, limit: this.pageSize })
        })
      }
    }
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
.pagination-container.hidden {
  display: none;
}
</style>